<template>
  <div id="app">
    <!-- 認証済みの時はメインの画面を表示 -->
    <div v-if="signedIn" class="app-container">
      <el-container style="height: 100vh; border: 1px solid #eee">
        <!--ヘッダ-->
        <Header v-bind:username="username" @signOut="signOut"></Header>
        <el-main>
          <!-- 検索条件 -->
          <ConditionForms :disabled="disabled"></ConditionForms>
          <el-divider></el-divider>
          <!-- グラフ -->
          <el-row class="plot-row" type="flex" justify="center">
            <el-col :span="24">
              <Plot :disabled="disabled"></Plot>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </div>

    <!-- 認証していない時はログイン画面を表示 -->
    <div v-else style="height: 100vh; background-color: white" class="login-container" />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import ConditionForms from '@/components/ConditionForms.vue'
import Plot from '@/components/Plot.vue'
import Auth from '@/composable/auth'

export default {
  name: 'app',
  components: {
    Header,
    ConditionForms,
    Plot
  },

  data() {
    return {
      signedIn: false,
      username: '',
      disabled: true,
    }
  },

  methods: {
    signOut: async function () {
      this.signedIn = false;
      await this.$store.dispatch('initialize');
      sessionStorage.removeItem('token');
      Auth.login(
        process.env.VUE_APP_LOGIN_URL,
        process.env.VUE_APP_CLIENT_ID,
      );
    },

  },

  computed: {
  },

  async created() {
    //ライセンス情報を取得
    if (sessionStorage.getItem('token') !== null) {
      await Auth.verify(
        process.env.VUE_APP_AUTH_ROOT + '/auth',
        sessionStorage.getItem('token'),
        process.env.VUE_APP_CLIENT_ID
      ).then(({ isSuccess }) => this.disabled = !isSuccess)
    }

  },

  beforeCreate() {
    if (window.location.hash !== '') {
      //ログイン完了後のtoken保存
      const params = new URLSearchParams(window.location.hash.slice(1));
      sessionStorage.setItem('token', params.get('id_token'));
      window.location.replace('/')
    }
    else {
      if (sessionStorage.getItem('token') === null) {
        //ログイン画面への遷移
        Auth.login(
          process.env.VUE_APP_LOGIN_URL,
          process.env.VUE_APP_CLIENT_ID,
        );
      } else {
        //ログイン情報等の取得
        this.$nextTick(async () => {
          this.signedIn = true;
          this.username = await Auth.getNameFromToken(sessionStorage.getItem('token'))
        })
      }
    }
  },

};
</script>

<style>
html {
  height: 100%;
}
body {
  margin: 0px;
  height: 100%;
}
</style>

<style scoped>
.app-container .el-main {
  position: fixed;
  top: 60px;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
}

.el-row {
  margin-top: 10px;
}
</style>
